
















export default {
  name: 'epb-switch',
  props: {
    value: Boolean,
    color: {
      type: String,
      default: 'primary'
    },
    switchPosition: { // left & right
      type: String,
      default: 'left'
    },
    disabled: Boolean
  }
};
